import React, { useState } from "react";
import "./navigation.css";
import { Dropdown } from "react-bootstrap";
import logOut from "../../assets/log-out.svg";
import { Outlet } from "react-router-dom";
import { getActionSucces } from "../../redux/actions/burgerAction";
import { useDispatch } from "react-redux";
import axios from "axios";
import { useEffect } from "react";
import defaultImage from "../../assets/image/Default-User.png";

function Navigation() {
  const dispatch = useDispatch();
  const userId = window.sessionStorage.getItem("dataLogin");
  const [data, setData] = useState(false);

  const getUserById = async () => {
    const rest = axios.create({
      baseURL: "https://mobile.amospa.com",
      headers: { Authorization: `Bearer ${userId}` },
    });
    const id = await rest.get("/jwt/token");
    let result = await axios.get(
      `https://mobile.amospa.com/staff/${id.data.data}`
    );
    setData(result.data.data[0]);
  };

  const handleLogout = () => {
    window.sessionStorage.clear();
    window.location.href = "/";
  };

  useEffect(() => {
    getUserById();
  }, []);

  return (
    <div className="wrapper-navigation">
      <div className="navigation">
        <div
          className="burger-menu"
          onClick={() => dispatch(getActionSucces("openSidebar"))}
        >
          <div></div>
          <div></div>
          <div></div>
        </div>
        <div className="wrapper-nav">
          <img
            className="img-user"
            src={data ? data.image : defaultImage}
            alt=""
          />
          <Dropdown>
            <Dropdown.Toggle
              variant="white"
              id="dropdown-basic"
              className="me-4 p-0"
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "start",
              }}
            >
              {data ? data.name : "Nama User"}
            </Dropdown.Toggle>

            <Dropdown.Menu>
              <Dropdown.Item href="#/action-1" onClick={handleLogout}>
                <img className="logOut-nav" src={logOut} alt="" />
                Logout
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </div>
      </div>
      <div className="content-amo">
        <div className="right-amo">
          <Outlet />
        </div>
      </div>
    </div>
  );
}

export default Navigation;
